import axios from 'axios';
import { getNavigateFunction } from '../utils/navigationService';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',  
    timeout: 10000,
});

// Add API prefix to all requests
api.interceptors.request.use(
    (config) => {
        // Add /api prefix to all requests
        config.url = `/api${config.url}`;

        // Increase timeout for file uploads (10 minutes)
        if (config.data instanceof FormData) {
            config.timeout = 600000; // 10 minutes for file uploads
        }

        // Don't add token for public category routes
        const publicPaths = ['/categories', '/products/category'];
        const isPublicPath = publicPaths.some(path =>
            config.url.includes(path) && config.method === 'get'
        );

        if (!isPublicPath) {
            const token = localStorage.getItem('token');
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const publicPaths = ['/categories', '/products/category'];
        const isPublicPath = publicPaths.some(path =>
            error.config?.url?.includes(path) && error.config?.method === 'get'
        );

        if (!isPublicPath && error.response?.status === 401) {
            // Session expired - clear everything and show message
            localStorage.removeItem('token');
            localStorage.removeItem('userRole');
            localStorage.removeItem('userLocation');

            // Store a flag to show session expired message
            sessionStorage.setItem('sessionExpired', 'true');

            const navigate = getNavigateFunction();
            if (navigate) {
                // Navigate to login page on session expiration
                navigate('/login', { replace: true });
            } else {
                window.location.href = '/login';
            }
        } else if (!isPublicPath && error.response?.status === 403) {
            // Forbidden - insufficient permissions
            const navigate = getNavigateFunction();
            if (navigate) {
                navigate('/dashboard', { replace: true });
            }
        }
        return Promise.reject(error);
    }
);

export const setAuthToken = (token) => {
    if (token) {
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete api.defaults.headers.common['Authorization'];
    }
};

// Add this function to check if the user is authenticated
export const isAuthenticated = () => {
    return !!localStorage.getItem('token');
};

export const signOut = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userRole');
    delete api.defaults.headers.common['Authorization'];

    const navigate = getNavigateFunction();
    if (navigate) {
        navigate('/');
    } else {
        window.location.href = '/';
    }
};

export default api;